export default __webpack_public_path__ + "static/media/search.80cf8866.svg";